/**
 * CloseButton — Bouton de fermeture de la modale
 *
 * Icône ✕ SVG inline. Zone tactile 44×44px (WCAG 2.5.5).
 * Passe les props de positionnement Chakra (position, top, right, etc.)
 *
 * Props :
 *   onClick  {function}  — callback de fermeture
 *   ...rest              — props Chakra Box (position, top, right, zIndex…)
 */

import React from 'react'
import { Box } from '@chakra-ui/react'

const CloseButton = ({ onClick, ...rest }) => {
  return (
    <Box
      as="button"
      onClick={onClick}
      aria-label="Fermer"
      display="flex"
      alignItems="center"
      justifyContent="center"
      w="44px"
      h="44px"
      bg="transparent"
      border="none"
      cursor="pointer"
      borderRadius="full"
      _hover={{ bg: 'rgba(26,29,36,0.06)' }}
      _active={{ bg: 'rgba(26,29,36,0.12)' }}
      transition="background 0.15s ease"
      {...rest}
    >
      <svg
        width={22} height={22}
        viewBox="0 0 24 24"
        fill="none"
        stroke="#1A1D24"
        strokeWidth={2}
        strokeLinecap="round"
        aria-hidden="true"
      >
        <line x1={18} y1={6}  x2={6}  y2={18}/>
        <line x1={6}  y1={6}  x2={18} y2={18}/>
      </svg>
    </Box>
  )
}

export default CloseButton
